// The renderer registry calls build(state, nowSec) with no view state, so the map
// pushes the current zoom here and the flights layer reads it to gate callsign
// labels (showing them only when zoomed in enough to be legible).

/** Show callsign labels at or above this MapLibre zoom level. */
export const FLIGHT_LABEL_ZOOM = 12;

let currentZoom = 0;
export function setFlightZoom(z: number): void {
  currentZoom = z;
}
export function flightLabelsVisible(): boolean {
  return currentZoom >= FLIGHT_LABEL_ZOOM;
}
